'use strict';

exports.__esModule = true;

var _reactRouter = require('react-router');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _reactRouter.Redirect;
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-dom/Redirect.js
 ** module id = 542
 ** module chunks = 0
 **/